import { colors } from './colors';
import { ThemeConfig } from 'antd';

export const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.PRIMARY,
    colorFillSecondary: colors.SECONDARY,
    borderRadius: 6,
    colorText: colors.COLOR_TEXT,
  },
  components: {
    Layout: {
      bodyBg: colors.BG_COLOR,
      lightSiderBg: colors.SECONDARY,
      lightTriggerBg: colors.SECONDARY,
      lightTriggerColor: colors.WHITE,
    },
    Menu: {
      itemBg: colors.TRANSPARENT,
      itemColor: colors.WHITE,
      itemHoverBg: colors.PRIMARY_BG_HOVER,
      fontSize: 16,
      itemSelectedBg: colors.PRIMARY,
      itemSelectedColor: colors.WHITE,
    },
    Typography: {
      titleMarginBottom: 0,
      titleMarginTop: 0,
    },
    Button: {
      fontSize: 14,
      borderRadius: 6,
      colorText: colors.PRIMARY,
      colorPrimaryText: colors.WHITE,
      defaultBg: colors.WHITE,
      defaultBorderColor: colors.PRIMARY,
      defaultHoverBorderColor: colors.PRIMARY_BORDER_HOVER,
    },
    Table: {
      headerBg: colors.PRIMARY_BG_HOVER,
      headerColor: colors.COLOR_TEXT_COMPONENTS,
      headerBorderRadius: 8,
      rowHoverBg: colors.PRIMARY_BG_HOVER,
      footerBg: colors.BG_COLOR,
      colorBgContainer: colors.BG_COLOR,
      borderColor: colors.COLOR_BORDER,
      headerSplitColor: colors.COLOR_BORDER,
      rowSelectedBg: colors.PRIMARY_BG_HOVER,
      rowSelectedHoverBg: colors.PRIMARY_BG_HOVER,
      cellPaddingInline: 16,
      cellPaddingBlock: 8,
    },
    Badge: {
      colorText: colors.PRIMARY_HOVER,
    },
    Input: {
      colorPrimaryHover: colors.PRIMARY,
      activeBorderColor: colors.PRIMARY,
      activeShadow: colors.BG_COLOR,
      colorTextPlaceholder: colors.PRIMARY_HOVER,
    },
    DatePicker: {
      colorPrimaryHover: colors.PRIMARY,
      activeBorderColor: colors.PRIMARY,
      activeShadow: colors.BG_COLOR,
    },
    Slider: {
      handleColor: colors.PRIMARY,
      handleActiveColor: colors.PRIMARY,
      trackBg: colors.PRIMARY,
      trackHoverBg: colors.PRIMARY,
    },
    Steps: {
      colorTextLabel: colors.WHITE,
    },
  },
};
